"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerButton = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _DatePickerButton = require("./DatePickerButton.styles");
var _excluded = ["children", "pressed", "today"];
/**
 * @related [`Button`, `DatePicker`]
 * @since 8.0.0
 */

var DatePickerButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var children = _ref.children,
    pressed = _ref.pressed,
    today = _ref.today,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_DatePickerButton.StyledDatePickerButton, (0, _extends2.default)({
    ref: forwardedRef,
    "aria-pressed": pressed ? true : undefined
  }, props), children);
});
exports.DatePickerButton = DatePickerButton;
DatePickerButton.displayName = 'DatePickerButton';
DatePickerButton.propTypes = {
  children: _propTypes.default.node,
  pressed: _propTypes.default.bool,
  today: _propTypes.default.bool,
  /** @ignore */
  buttonType: _propTypes.default.string,
  /** @ignore */
  borderless: _propTypes.default.bool,
  /** @ignore */
  size: _propTypes.default.string
};
DatePickerButton.defaultProps = {
  children: null,
  pressed: false,
  today: false,
  buttonType: 'tertiary',
  borderless: true,
  size: 'sm'
};